import {Splide} from '@splidejs/splide';

export default class BlockSlider {
    constructor() {
        this.applyEvents();
    }

    applyEvents() {
        const self = this;
        const sliders = document.querySelectorAll('.block-slider');
        const models = document.querySelector('#models');
        if (sliders) {
            sliders.forEach((slider) => {
                let options = {
                    'type': 'loop',
                    'perPage': 1,
                    'perMove': 1,
                    'lazyLoad': 'nearby',
                    'gap': '2rem',
                    'mediaQuery': 'min',
                    'pagination': true,
                    'breakpoints': {
                        '768': {
                            'perPage': 3,
                        }
                    }
                }
                if (models) {
                    options['pagination'] = true;
                    options['breakpoints'] = {
                        '768': {
                            'perPage': 2,
                        },
                        '1200': {
                            'perPage': 3,
                        }
                    };
                }
                let slides = slider.querySelectorAll('.splide__slide');
                if (slides.length < 4) {
                    options['type'] = 'slide';
                    options['pagination'] = false;
                    // options['arrows'] = false;
                }
                const splide = new Splide(slider, options);
                splide.mount();

                splide.on('mounted', function () {
                    if (splide.length <= splide.options.perPage) {
                        splide.options.perPage = splide.length;
                    }
                });
            });
        }
    }
}